// @flow

import React from 'react';
import { Progress } from '@riseart/antd-provider';

import { progressBarCls, progressBarMainCls, progressBarTextCls } from './ProgressBar.less';

type Props = {
  percent: number,
  children: any,
};

/**
 * Progress Bar
 *
 * @param {Props} props
 * @returns {XML}
 */
export const ProgressBar = (props: Props) => (
  <div className={progressBarCls}>
    <div className={progressBarMainCls}>
      <Progress percent={props.percent} showInfo={false} size={{ height: 3 }} />
    </div>
    {props.children && <div className={progressBarTextCls}>{props.children}</div>}
  </div>
);
